import { defineLocaleTargets } from './utilities';

export const NavigationLocales = defineLocaleTargets('navigation', <const>{
	links: '',
	loginLabel: '',
});
